import ProductPage from './ProductPage';

export default ProductPage;
export { getServerSideProps } from './serverSideProps';
